import { render } from "./purchase-list.vue?vue&type=template&id=0218a69c"
import script from "./purchase-list.vue?vue&type=script&lang=js"
export * from "./purchase-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__